import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import LegalLinks from '../../components/LegalLinks';
import { LEGAL_EMAIL, LEGAL_UPDATED } from '../../config/legal';
import '../landing/landing.css';

// A value the owner still has to fill in (src/config/legal.js): shown in
// red so a missing name or NIF can't go unnoticed.
export const Fill = ({ value, label }) =>
  value ? <>{value}</> : <mark className="lp-pending">[pendiente: {label}]</mark>;

export const Email = () => (
  <a href={`mailto:${LEGAL_EMAIL}`} className="underline underline-offset-4">
    {LEGAL_EMAIL}
  </a>
);

const LegalLayout = ({ title, intro, children }) => {
  useEffect(() => {
    document.title = `${title} · webspector`;
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <div className="lp flex min-h-screen flex-col">
      <header className="mx-auto w-full max-w-3xl px-4 py-6 sm:px-6">
        <Link to="/" className="lp-display text-2xl">
          webspector<span className="text-[var(--lp-lime)]">.</span>
        </Link>
      </header>

      <main className="mx-auto w-full max-w-3xl flex-1 px-4 pb-20 pt-6 sm:px-6">
        <p className="lp-kicker">Información legal</p>
        <h1 className="lp-display mt-4 text-[clamp(2.4rem,6vw,3.75rem)]">{title}</h1>
        <p className="mt-4 text-sm text-[var(--lp-muted)]">Última actualización: {LEGAL_UPDATED}</p>
        {intro && <p className="mt-8 text-lg leading-relaxed text-[var(--lp-muted)]">{intro}</p>}
        <div className="lp-legal mt-10">{children}</div>
      </main>

      <footer className="mx-auto flex w-full max-w-3xl flex-col gap-4 border-t border-[var(--lp-line)] px-4 py-8 text-sm text-[var(--lp-muted)] sm:px-6">
        <LegalLinks />
        <span>
          Dudas: <Email />
        </span>
      </footer>
    </div>
  );
};

export default LegalLayout;
